import React, { createContext, useContext, useState, useEffect } from 'react';

const FlowContext = createContext();

export const FlowProvider = ({ children }) => {
  const [userId, setUserId] = useState(1); // Default to 1 (will be overwritten by OrganisationID)
  const [userGroup, setUserGroup] = useState('user'); // Default to restricted role
  const [organisationID, setOrganisationID] = useState(null);
  const [userName, setUserName] = useState('');
  const [userOrg, setUserOrg] = useState('');

  const [flowId, setFlowId] = useState(null);
  const [flowName, setFlowName] = useState("");
  const [training, setTraining] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: 'success' });
  const [autoSaveEnabled, setAutoSaveEnabled] = useState(() => {
    const saved = localStorage.getItem('autoSaveEnabled');
    return saved === 'true';
  });

  // Persist autoSaveEnabled
  useEffect(() => {
    localStorage.setItem('autoSaveEnabled', autoSaveEnabled);
  }, [autoSaveEnabled]);

  // API Base URL
  const API_BASE = "http://10.0.9.7:3001";

  useEffect(() => {
    // Check for token in URL
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    if (token) {
      console.log('Token found, fetching session data...');
      fetch(`${API_BASE}/api/auth/session/${token}`)
        .then(res => {
          if (!res.ok) throw new Error('Failed to valid credentials');
          return res.json();
        })
        .then(data => {
          if (data.userID) {
            // CRITICAL: We are using OrganisationID as the "User ID" for flow storage
            // This enables the Shared Workspace model requested.
            const orgId = data.organisationID || data.userID;

            setUserId(orgId);
            setOrganisationID(data.organisationID);
            setUserGroup((data.userGroup || 'user').toLowerCase());
            setUserName(data.userName);
            setUserOrg(data.userOrganisation);

            // Optional: Clean URL
            // window.history.replaceState({}, document.title, window.location.pathname);
          }
        })
        .catch(err => {
          console.error('Session auth error:', err);
          showNotification('Authentication failed: ' + err.message, 'error');
        });
    }
  }, []);

  const showNotification = (message, type = 'success') => {
    setNotification({ show: true, message, type });
    // Auto-hide after 5 seconds
    setTimeout(() => {
      setNotification({ show: false, message: '', type: 'success' });
    }, 5000);
  };

  const hideNotification = () => {
    setNotification({ show: false, message: '', type: 'success' });
  };

  return (
    <FlowContext.Provider value={{
      userId, setUserId,
      userGroup, setUserGroup,
      organisationID,
      userName,
      userOrg,
      flowId, setFlowId,
      flowName, setFlowName,
      training, setTraining,
      notification, showNotification, hideNotification,
      autoSaveEnabled, setAutoSaveEnabled
    }}>
      {children}
    </FlowContext.Provider>
  );
};

export const useFlowContext = () => useContext(FlowContext); 
